// LE Miami 2026 photos shared by the hero (desktop) and the "Who We're Looking For"
// section (desktop portrait + the mobile side-by-side pair). Single-sourced here so the
// URLs and captions don't drift as these photos move around the page.

export const ALISHA_PHOTO = {
    // Image Library: "Alisha Myers, Courtney Eisen, Alexandra Nett-2".
    src: 'https://cdnweb.luxrallytravel.com/images/become-an-agent-hero-alisha-1781759662.jpg',
    alt: 'Alisha Myers with Courtney Eisen and Lexie Nett at LE Miami',
    caption:
        'Alisha Myers (left), a top agent, stands with our CMO and Co-founder, Courtney Eisen (center), and Brand Manager, Lexie Nett (right).',
} as const;

export const BRANDON_MEG_PHOTO = {
    // Image Library: "Brandon Haen, Meg Johnson-2" (design_images #665).
    src: 'https://cdnweb.luxrallytravel.com/design-studio/images/2026/06/6dbd543e-39a0-4c0e-a865-30996195380b.jpg',
    alt: 'Brandon Haen with Meg Johnson at LE Miami',
    caption: 'Luxury Sales Manager, Brandon Haen (left) with New Agent Sales Manager, Meg Johnson (right).',
} as const;
